// @flow

const EVENT_NAME_CART_UPDATED = "retail-cart__cart-items-updated";
const EVENT_NAME_CART_UPDATED_FAIL = "retail-cart__cart-items-updated-fail";

import { requirePolyfill } from "./apply-polyfill";

requirePolyfill().then(init);

function init() {
    const ns = window;
    ns.CART = ns.CART || {};
    var fn = (ns.CART.fn = ns.CART.fn || {});
    fn.getCart = getCart;
    fn.addItems = addItems;
    fn.updateItem = updateItem;
    fn.removeItem = removeItem;
    fn.clearCart = clearCart;
}

function getCart(successCb, errorCb) {
    return get("/bathrooms/cart/service/carts")
        .then(wrapEvtSuccess(successCb, convertProductsArrayToItemCount))
        .catch(wrapEvtFail(errorCb));
}

function addItems(data, quoteId, successCb, errorCb) {
    throwIf(
        !data || !data.addItems,
        "must contains addItems in first paramter"
    );
    throwIf(!data.addItems.forEach, "addItems must be array");
    throwIf(
        data.quoteId && !isPositiveNumber(data.quoteId),
        "quoteId must be positive number in string type"
    );
    data.addItems.forEach(function(i) {
        checkItemType(i, false);
    });
    const body = {
        quoteId: quoteId,
        products: data.addItems
    };
    return post("/bathrooms/cart/service/carts", body)
        .then(wrapEvtSuccess(successCb, convertProductsArrayToItemCount))
        .catch(wrapEvtFail(errorCb));
}
function updateItem(data, successCb, errorCb) {
    throwIf(
        !data || !data.updateItem,
        "must contains updateItem in first paramter"
    );
    checkItemType(data.updateItem, false);
    return put("/bathrooms/cart/service/carts/items", data)
        .then(wrapEvtSuccess(successCb, convertProductsArrayToItemCount))
        .catch(wrapEvtFail(errorCb));
}

function removeItem(data, successCb, errorCb) {
    throwIf(
        !data || !data.deleteItem,
        "must contains deleteItem in first paramter"
    );
    checkItemType(data.deleteItem, true);
    return deleteReq("/bathrooms/cart/service/carts/items", data)
        .then(wrapEvtSuccess(successCb, convertProductsArrayToItemCount))
        .catch(wrapEvtFail(errorCb));
}

function clearCart(successCb, errorCb) {
    return deleteReq("/bathrooms/cart/service/carts")
        .then(wrapEvtSuccess(successCb, convertProductsArrayToItemCount))
        .catch(wrapEvtFail(errorCb));
}

function checkItemType(item, isQuantityOptional) {
    throwIf(isEmpty(item), "item cannot be empty");
    throwIf(
        !isPositiveNumber(item.productCode),
        "item.productCode is required and must be number in string type"
    );
    if (isQuantityOptional === true) {
        throwIf(
            !isEmpty(item.quantity) && !isPositiveNumber(item.quantity),
            "item.quantity must be a number > 0"
        );
    } else {
        throwIf(
            !isPositiveNumber(item.quantity),
            "item.quantity must be a number > 0"
        );
    }
    throwIf(
        !isEmpty(item.quoteId) && !isPositiveNumber(item.quoteId),
        "item.quoteId (if present) must be a positive number in string type"
    );
    throwIf(
        !isEmpty(item.lineId) && !isPositiveNumber(item.lineId),
        "item.lineId (if present) must be a positive number in string type"
    );
    throwIf(isEmpty(item.pack), 'item.pack must be "ONE" or "TWO"');
    throwIf(
        item.pack !== "ONE" && item.pack !== "TWO",
        'item.pack must be "ONE" or "TWO"'
    );
}
function isEmpty(obj) {
    return obj === null || obj === undefined || "" + obj === "";
}
function isPositiveNumber(obj) {
    try {
        var val = parseInt(obj);
        return !isNaN(val) && val > 0;
    } catch (e) {
        return false;
    }
}
function throwIf(cond, msg) {
    if (cond === true) {
        throw new Error(msg);
    }
}

function toJson(r) {
    return r.json();
}

function baseConfig(extra) {
    return Object.assign(
        {},
        {
            method: "GET",
            headers: {
                "content-type": "application/json"
            },
            cache: "no-cache",
            credentials: "same-origin"
        },
        extra
    );
}

function get(url) {
    return window.fetch(url, baseConfig()).then(toJson);
}

function post(url, bodyObj) {
    return window
        .fetch(
            url,
            baseConfig({
                method: "POST",
                body: JSON.stringify(bodyObj)
            })
        )
        .then(toJson);
}

function put(url, bodyObj) {
    return window
        .fetch(
            url,
            baseConfig({
                method: "PUT",
                body: JSON.stringify(bodyObj)
            })
        )
        .then(toJson);
}

function deleteReq(url, bodyObj) {
    return window
        .fetch(
            url,
            baseConfig({
                method: "DELETE",
                body: JSON.stringify(bodyObj)
            })
        )
        .then(toJson);
}

function convertProductsArrayToItemCount(data: ?{ products: any[] }) {
    if (data && data.products) {
        return {
            itemCount: data.products.length
        };
    } else {
        return {
            itemCount: 0
        };
    }
}

function wrapEvtSuccess(cb, evtDataConverter?: ?(any) => Object) {
    return function(data) {
        let err = null;
        try {
            let newData = data;
            if (evtDataConverter) {
                newData = evtDataConverter(data);
            }
            dispatchCartEvent(EVENT_NAME_CART_UPDATED, newData);
        } catch (e) {
            err = e;
        }

        cb && cb(data);

        if (err) {
            throw err;
        }
    };
}

function wrapEvtFail(cb) {
    return function(promiseErrorObj) {
        let err = null;
        try {
            dispatchCartEvent(EVENT_NAME_CART_UPDATED_FAIL, promiseErrorObj);
        } catch (e) {
            err = e;
        }

        cb && cb(promiseErrorObj, err);

        if (err) {
            throw err;
        }
    };
}

function dispatchCartEvent(eventName: string, data?: ?Object) {
    window.dispatchEvent(
        new CustomEvent(eventName, {
            detail: data
        })
    );
}
